import { FC, Fragment, useCallback, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import { useReturn } from '@hsp/react-component-library';
import { isDefined } from '@hsp/utilities';

import { useLogout } from 'hooks/mutations';
import { useEndSession } from 'hooks/session';
import { ILoginLocationState } from 'types/pages/authentication/login';
import { ILocation, ILocationState } from 'types/router';
import { buildUrl } from 'utilities/strings';

const LogoutPage: FC = () => {
  const { endSessionAsync } = useEndSession();
  const { state } = useLocation() as ILocation<ILoginLocationState & ILocationState>;
  const { isSuccess, logout } = useLogout();
  const navigate = useNavigate();
  const { setReturnUrl } = useReturn();

  const { from, revoke } = state ?? {};

  const redirect = useCallback(() => {
    navigate(buildUrl('Root.children.Login'), {
      replace: true,
    });
  }, [navigate]);

  useEffect(() => {
    if (isDefined(revoke) && revoke) {
      logout();
    } else {
      endSessionAsync().then(() => redirect());
    }
  }, [endSessionAsync, logout, redirect, revoke]);

  useEffect(() => {
    if (isSuccess) {
      endSessionAsync().then(() => {
        setReturnUrl(isDefined(from) ? from.pathname : undefined);
        redirect();
      });
    }
  }, [endSessionAsync, from, isSuccess, redirect, setReturnUrl]);

  return <Fragment />;
};

export default LogoutPage;
